import { render, staticRenderFns } from "./MatchOptionsRouterView.vue?vue&type=template&id=a0e61be8&scoped=true&"
import script from "./MatchOptionsRouterView.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e61be8",
  null
  
)

export default component.exports